import React, { useState } from "react";
import styled, { ThemeProvider } from "styled-components";
import { theme } from "../../../Style/theme";
import {
  format,
  addMonths,
  subMonths,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  eachDayOfInterval,
  isSameMonth,
  isSameDay,
} from "date-fns";
import { ko } from "date-fns/locale";

const CalendarWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: repeat(6, 1fr); /* 6개의 행으로 나눔 */
  gap: 10px;
  width: 536px;
  height: 498px;
  padding: 20px;
  margin-left: -20px;
`;

const Weekday = styled.div`
  text-align: center;
  font-weight: bold;
  margin-left: ${(props) => props.left}px;
  margin-right: ${(props) => props.right}px;
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  color: white;
`;

const WeekdayDiv = styled.div`
  display: flex;
  height: 64px;
  width: 536px;
  /* margin-left: 25px; */
  align-items: center;
  justify-content: flex-start;
  padding-top: 5px;
  margin-bottom: -10px;
`;

const HRLight = styled.div`
  position: absolute;
  width: 534px;
  height: 0px;
  /* margin-left: 25px; */
  margin-top: ${(props) => props.top}px;

  border: 1px solid #ffffff;
`;

const ScheduleDot = styled.img`
  position: absolute;
  width: 6px;
  height: 6px;
  margin-bottom: 20px;
  margin-right: 25px;
`;

const Day = styled.div`
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 1px solid
    ${({ isSameDayCheck }) => (isSameDayCheck ? "#FFFFFF" : "transparent")};
  cursor: ${({ iscurrentmonth }) => (iscurrentmonth ? "pointer" : "default")};

  color: ${({ iscurrentmonth, istoday, ishighlighted, isSameDayCheck }) =>
    isSameDayCheck
      ? "#FFFFFF"
      : iscurrentmonth
      ? istoday
        ? "#143551"
        : ishighlighted
        ? "#FFFFFF"
        : "#FFFFFF"
      : "transparent"};

  background-color: ${({
    iscurrentmonth,
    istoday,
    ishighlighted,
    isSameDayCheck,
  }) =>
    isSameDayCheck
      ? "transparent"
      : iscurrentmonth
      ? istoday
        ? "#FFFFFF"
        : ishighlighted
        ? "transparent"
        : "transparent"
      : "transparent"};

  &:hover {
    background-color: ${({ iscurrentmonth, istoday, ishighlighted }) =>
      iscurrentmonth
        ? istoday
          ? "rgba(255, 255, 255, 0.1)"
          : ishighlighted
          ? "rgba(255, 255, 255, 0.1)"
          : "rgba(255, 255, 255, 0.1)"
        : "transparent"};
  }

  &:active {
    background-color: #ffffff;
    color: #143551;
    background-color: ${({ iscurrentmonth, istoday, ishighlighted }) =>
      iscurrentmonth
        ? istoday
          ? "#FFFFFF"
          : ishighlighted
          ? "#FFFFFF"
          : "#FFFFFF"
        : "transparent"};
  }
`;

const TitleDiv = styled.div`
  display: flex;
  height: 38px;
  width: 760px;
  justify-content: flex-end;
  align-items: center;
  margin-top: -48px;
  margin-left: 20px;
`;

const Caption1 = styled.div`
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  text-decoration: none;
  margin-left: ${(props) => props.left}px;
  color: white;
`;

const ScheduleTitle = styled.div`
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 28px;
  text-decoration: none;
  margin-right: 37px;
  margin-left: ${(props) => props.left}px;
  color: white;
`;

const Button = styled.button`
  background-color: rgba(0, 0, 0, 0);
  padding: 20px;
  border: none;
  cursor: pointer;
`;

const ArrowImage = styled.img`
  width: 9px;
  height: 16px;
`;

const BodyDiv = styled.div`
  display: flex;
  height: 498px;
  width: 1050px;
  /* background-color: yellow; */
`;

const CalendarDiv = styled.div`
  height: 498px;
  width: 536px;
  background-color: rgba(20, 53, 81, 1);
`;

const ScheduleDiv = styled.div`
  height: 429px;
  width: 481px;
  padding: 0 32px;
  margin-top: 10px;
  margin-left: 75px;
  /* background-color: green; */
  background-color: rgba(255, 255, 255, 0.1);
  overflow-y: scroll; /* Enable vertical scrolling */
  scrollbar-color: #d0d0d0;
`;

const ScheduleDate = styled.div`
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  color: white;
  margin-top: 15px;
  margin-bottom: 24px;
`;

const EventTitleDiv = styled.div`
  height: 30px;
  display: flex;
  width: 183px;
  /* background-color: gray; */
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 16px;
`;

const CategoryDiv = styled.div`
  width: 66px;
  height: 30px;
  background: ${({ IsselectedCategory }) =>
    IsselectedCategory ? "#FFFFFF" : "transparent"};
  border-radius: 60px;
  justify-content: center;
  align-items: center;
  display: flex;
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  color: #143551;
  margin-right: 12px;
`;

const EventTitle = styled.div`
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: #ffffff;
`;

const EventContet = styled.div`
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #ffffff;
  width: 360px;
`;

const Calendar = () => {
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTitle, setSelectedTitle] = useState("");
  const [selectedContent, setSelectedContent] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedDay, setSelectedDay] = useState("");

  // JSON 데이터
  const data = [
    {
      date: "2023-06-20",
      title: "라이브 통역 사업",
      content:
        "한동대학교 내에서 진행되는 행사들을 외국인 학생들도 함께 하하 참여할 수 있는 기회를 늘리기 위해 영어 통역을 제공해주는 사업 평의회 1차 정기총회에 참석하는 외국인 팀장들을 위해 어디서? 아 글로벌국에서 통역을 제공이라하네 그것을 하기로 했습니다 네네네",
      category: "글로벌국",
    },
    {
      date: "2023-07-12",
      title: "제목2",
      content: "내용2",
      category: "글로벌국",
    },
    {
      date: "2023-08-20",
      title: "제목1",
      content:
        "한동대학교 내에서 진행되는 행사들을 외국인 학생들도 함께 하하 참여할 수 있는 기회를 늘리기 위해 영어 통역을 제공해주는 사업 평의회 1차 정기총회에 참석하는 외국인 팀장들을 위해 어디서? 아 글로벌국에서 통역을 제공이라하네 그것을 하기로 했습니다 네네네한동대학교 내에서 진행되는 행사들을 외국인 학생들도 함께 하하 참여할 수 있는 기회를 늘리기 위해 영어 통역을 제공해주는 사업 평의회 1차 정기총회에 참석하는 외국인 팀장들을 위해 어디서? 아 글로벌국에서 통역을 제공이라하네 그것을 하기로 했습니다 네네네한동대학교 내에서 진행되는 행사들을 외국인 학생들도 함께 하하 참여할 수 있는 기회를 늘리기 위해 영어 통역을 제공해주는 사업 평의회 1차 정기총회에 참석하는 외국인 팀장들을 위해 어디서? 아 글로벌국에서 통역을 제공이라하네 그것을 하기로 했습니다 네네네한동대학교 내에서 진행되는 행사들을 외국인 학생들도 함께 하하 참여할 수 있는 기회를 늘리기 위해 영어 통역을 제공해주는 사업 평의회 1차 정기총회에 참석하는 외국인 팀장들을 위해 어디서? 아 글로벌국에서 통역을 제공이라하네 그것을 하기로 했습니다 네네네한동대학교 내에서 진행되는 행사들을 외국인 학생들도 함께 하하 참여할 수 있는 기회를 늘리기 위해 영어 통역을 제공해주는 사업 평의회 1차 정기총회에 참석하는 외국인 팀장들을 위해 어디서? 아 글로벌국에서 통역을 제공이라하네 그것을 하기로 했습니다 네네네한동대학교 내에서 진행되는 행사들을 외국인 학생들도 함께 하하 참여할 수 있는 기회를 늘리기 위해 영어 통역을 제공해주는 사업 평의회 1차 정기총회에 참석하는 외국인 팀장들을 위해 어디서? 아 글로벌국에서 통역을 제공이라하네 그것을 하기로 했습니다 네네네한동대학교 내에서 진행되는 행사들을 외국인 학생들도 함께 하하 참여할 수 있는 기회를 늘리기 위해 영어 통역을 제공해주는 사업 평의회 1차 정기총회에 참석하는 외국인 팀장들을 위해 어디서? 아 글로벌국에서 통역을 제공이라하네 그것을 하기로 했습니다 네네네한동대학교 내에서 진행되는 행사들을 외국인 학생들도 함께 하하 참여할 수 있는 기회를 늘리기 위해 영어 통역을 제공해주는 사업 평의회 1차 정기총회에 참석하는 외국인 팀장들을 위해 어디서? 아 글로벌국에서 통역을 제공이라하네 그것을 하기로 했습니다 네네네",
      category: "글로벌국",
    },
  ];

  const handlePrevMonth = () => {
    setCurrentMonth(subMonths(currentMonth, 1));
  };

  const handleNextMonth = () => {
    setCurrentMonth(addMonths(currentMonth, 1));
  };

  const getCalendarDays = () => {
    const startDate = startOfWeek(startOfMonth(currentMonth));
    const endDate = endOfWeek(endOfMonth(currentMonth));

    const days = eachDayOfInterval({ start: startDate, end: endDate });

    return days;
  };

  const renderCalendarDays = () => {
    const days = getCalendarDays();

    const handleDateClick = (day, formattedDate, title, content, category) => {
      const selectedDate = format(new Date(formattedDate), "yyyy.MM.dd(iii)", {
        locale: ko,
      });

      setSelectedDate(selectedDate);
      setSelectedTitle(title);
      setSelectedContent(content);
      setSelectedCategory(category);
      setSelectedDay(day);
    };

    return days.map((day) => {
      const formattedDate = format(day, "yyyy-MM-dd");
      const eventData = data.find((item) => item.date === formattedDate);

      return (
        <Day
          key={day}
          iscurrentmonth={isSameMonth(day, currentMonth)}
          istoday={isSameDay(day, new Date())}
          ishighlighted={eventData !== undefined}
          isSameDayCheck={isSameDay(day, selectedDay)}
          onClick={() =>
            handleDateClick(
              day,
              formattedDate,
              eventData?.title,
              eventData?.content,
              eventData?.category
            )
          }
        >
          {eventData && (
            <ScheduleDot
              src={require("../../../Assets/Img/MainHome_Img/일정Dot.png")}
            />
          )}
          {format(day, "d", { locale: ko })}
        </Day>
      );
    });
  };

  return (
    <ThemeProvider theme={theme}>
      <TitleDiv>
        <Button onClick={handlePrevMonth}>
          <ArrowImage
            src={require("../../../Assets/Img/MainHome_Img/LeftArrow_Calendar.png")}
          />
        </Button>
        <Caption1>{format(currentMonth, "yyyy.M")}</Caption1>
        <Button onClick={handleNextMonth}>
          <ArrowImage
            src={require("../../../Assets/Img/MainHome_Img/RightArrow_Calendar.png")}
          />
        </Button>
        <ScheduleTitle left={60}>총학생회 사업</ScheduleTitle>
      </TitleDiv>
      <HRLight top={60} />
      <HRLight top={10} />
      <BodyDiv>
        <CalendarDiv>
          <WeekdayDiv>
            <Weekday left={25}>일</Weekday>
            <Weekday left={61}>월</Weekday>
            <Weekday left={61}>화</Weekday>
            <Weekday left={61}>수</Weekday>
            <Weekday left={61}>목</Weekday>
            <Weekday left={61}>금</Weekday>
            <Weekday left={61}>토</Weekday>
          </WeekdayDiv>
          <CalendarWrapper>{renderCalendarDays()}</CalendarWrapper>
        </CalendarDiv>

        <ScheduleDiv>
          {selectedDate && (
            <>
              <ScheduleDate>{selectedDate}</ScheduleDate>
              <EventTitleDiv>
                <CategoryDiv IsselectedCategory={selectedCategory}>
                  {selectedCategory}
                </CategoryDiv>
                <EventTitle>{selectedTitle}</EventTitle>
              </EventTitleDiv>
              <EventContet>{selectedContent}</EventContet>
            </>
          )}
        </ScheduleDiv>
      </BodyDiv>
    </ThemeProvider>
  );
};

export default Calendar;
